import { FC, useCallback, useState } from "react";
import { createContext } from "use-context-selector";
import { IBioDocConfig } from "../common/interfaces/IBioDocConfig";
import { ITelemedicineData } from "../common/interfaces/ITelemedicineData";
import { VideoChatContextProvider } from "./VideoChatContext";

export type InfoContextType = {
  telemedicineData: ITelemedicineData;
  handleSetTelemedicineData: (data: ITelemedicineData) => void;
  bioDocConfig: IBioDocConfig;
  handleSetBioDocConfig: (data: IBioDocConfig) => void;
};

export const InfoContext = createContext({} as InfoContextType);

export const InfoContextProvider = ({ children }: { children: any }) => {
  const [telemedicineData, setTelemedicineData] = useState<ITelemedicineData>(
    {} as ITelemedicineData
  );
  const [bioDocConfig, setBioDocConfig] = useState<IBioDocConfig>(
    {} as IBioDocConfig
  );

  const handleSetTelemedicineData = useCallback((data: ITelemedicineData) => {
    setTelemedicineData(data);
  }, []);

  const handleSetBioDocConfig = useCallback((data: IBioDocConfig) => {
    setBioDocConfig(data);
  }, []);

  return (
    <VideoChatContextProvider>
      {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        <InfoContext.Provider
          value={{
            telemedicineData,
            handleSetTelemedicineData,
            bioDocConfig,
            handleSetBioDocConfig,
          }}
        >
          {children}
        </InfoContext.Provider>
      }
    </VideoChatContextProvider>
  );
};
